import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<h1 data-test=\"home-heading\">Welcome to my personal vue info site</h1><hr><p data-test=\"welcome-text\">Hi, on this website I collected the knowledge on VueJS that I gained from various courses from <strong><a target=\"_blank\" href=\"https://frontendmasters.com\">Frontendmasters</a></strong>. Special thanks to <a target=\"_blank\" href=\"https://twitter.com/sarah_edo\">Sarah Drasner</a> and <a target=\"_blank\" href=\"https://twitter.com/bencodezen\">Ben Hong</a>.</p>", 3)
const _hoisted_4 = [
  _hoisted_1
]

import { ref } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const minimumRating=ref(3);
  const changeRating = (event) => {
    minimumRating.value = event.target.value
  }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.intro)
  }, _hoisted_4, 2))
}
}

})